import {
  Box,
  Button,
  CircularProgress,
  Container,
  Drawer,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Cover from "./Cover";
import { makeStyles } from "@material-ui/core/styles";
import ProfileChangesSaved from "./ProfileChangesSaved";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
const useStyles = makeStyles((theme) => ({
  heading: {
    marginTop: "2em",
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "1em",
  },
  emailBox: {
    paddingLeft: "10px",
    padding: "5px",
    maxWidth: "100%",
    backgroundColor: "#f1f1f1",
    border: "2px solid black",
    borderRadius: "4px",
  },
  warningBox: {
    padding: "10px",
    border: "2px solid red",
    borderRadius: "4px",
  },
  warningText: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "red",
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: "auto",
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  drawerPaper: {
    width: "30vw",
  },
}));
export default function UpdateProfile({
  setUpdateProfileDrawer,
  user,
  setViewDetailsDrawer,
  handleRefresh,
  selectedRole,
  reqObj,
}) {
  const classes = useStyles();
  const [profileChangesSaved, setProfileChangesSaved] = useState(false);
  const [showEmailWarning, setShowEmailWarning] = useState(false);
  const [showRoleWarning, setShowRoleWarning] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (reqObj?.email_address) {
      setShowEmailWarning(true);
      //check if reqObj as email_address or role property
      //accordingly show the warnings
    } else {
      setShowEmailWarning(false);
    }
    if (reqObj?.role) {
      setShowRoleWarning(true);
    } else {
      setShowRoleWarning(false);
    }
  }, [reqObj]);

  const commitChanges = () => {
    setError(null);
    setLoading(true);
    const url = `${appUrl}/user/updateTeamMemberDetails`;

    const dataToSend = { ...reqObj };
    axios
      .post(url, [dataToSend])
      .then((res) => {
        // throw new Error("mock Error");
        if (res.data.status) {
          setProfileChangesSaved(true);
        } else {
          setError("Update failed.");
        }
      })
      .catch((err) => {
        setError(err.message || "An error occurred.");
      })
      .finally(() => setLoading(false));
  };
  function maskEmail(email) {
    if (!email) return ""; // Handle null or undefined input

    const [user, domain] = email.split("@");
    const maskedUser =
      user.slice(0, 1) + "*".repeat(user.length - 2) + user.slice(-1); // Mask everything except first and last char of username
    return maskedUser + "@" + domain;
  }
  const displayLoading = (
    <div style={{ textAlign: "center", marginTop: "1.5em" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );
  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",

        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginTop: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  return (
    <Box
      style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <Cover
        profilePic={user?.profile_pic}
        handleRefresh={handleRefresh}
        user={user}
        setViewDetailsDrawer={setViewDetailsDrawer}
      />
      <Container
        style={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Typography className={classes.heading}>
          Updates to team member account
        </Typography>
        <Typography style={{ marginBottom: "2em" }}>
          A confirmation email will be sent to
        </Typography>
        <Box className={classes.emailBox}>
          <Typography variant="body1">
            {maskEmail(user?.email_address)}
          </Typography>
        </Box>

        {(showEmailWarning || showRoleWarning) && ( // Conditionally render the "Warnings" heading
          <Typography className={classes.heading}>Warnings:</Typography>
        )}

        {showEmailWarning && (
          <Box className={classes.warningBox}>
            <Typography className={classes.warningText}>
              Email change: This action will deactivate the current email
              address and a login invite will be sent to the new email address.
            </Typography>
          </Box>
        )}

        {showRoleWarning && (
          <Box className={classes.warningBox} style={{ marginTop: "1em" }}>
            <Typography className={classes.warningText}>
              Role change: You are changing the role of the user. The team
              member may lose permissions to access few areas of the
              application.
            </Typography>
          </Box>
        )}
        {error && displayError}
        {loading && displayLoading}

        <Box className={classes.buttonContainer}>
          <Button
            size="small"
            variant="contained"
            disableElevation
            onClick={() => setUpdateProfileDrawer(false)}
            style={{ textTransform: "none" }}
          >
            Go back
          </Button>

          <Button
            className={classes.btnPrimary}
            variant="contained"
            size="small"
            //   color="primary"
            style={{
              textTransform: "none",
              backgroundColor: "#286acf",
              color: "#fff",
            }}
            onClick={commitChanges}
            // onClick={() => setProfileChangesSaved(true)}
          >
            Confirm changes
          </Button>
        </Box>
      </Container>
      <Drawer
        anchor="right"
        open={profileChangesSaved}
        onClose={() => setProfileChangesSaved(false)}
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
      >
        <ProfileChangesSaved
          setProfileChangesSaved={setProfileChangesSaved}
          user={user}
          setViewDetailsDrawer={setViewDetailsDrawer}
          handleRefresh={handleRefresh}
          reqObj={reqObj}
          selectedRole={selectedRole}
        />
      </Drawer>
    </Box>
  );
}
